import styled from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

import { Flex } from 'Components/UI/_Legacy'

import { LANDING_INLINE_PADDINGS } from 'Constants/Landing'

export const Wrapper = styled(Flex).attrs({
  width: 1,
  px: LANDING_INLINE_PADDINGS,
})`
  position: relative;
  background-color: ${themeGet('colors.calculator.light')};
  border-radius: 20px;
  overflow: hidden;
`
export const ChildContainer = styled(Flex).attrs({
  width: 1,
})`
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 2;
`

export const DotsContainer = styled(Flex)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
`
